// ###### IMPORTS
import React, { useState, useRef } from 'react';
import { useAssetsData } from '../moduleServices/assets_data_context';
import CardAssetsDetailed from './viewComponents/Detailed/CardAssetsDetailed';
import CardOperationsDetailed from './viewComponents/Detailed/CardOperationsDetailed';
import CardReturnsDetailed from './viewComponents/Detailed/CardReturnsDetailed';
import ModalAssetEdit from './viewComponents/Common/ModalAssetEdit';
import ModalReturnEdit from './viewComponents/Common/ModalReturnEdit';
import ModalSnapshotItemEdit from './viewComponents/Common/ModalSnapshotItemEdit';
import CardSnapshotsDetailed from './viewComponents/Detailed/CardSnapshotsDetailed';
import ModalSnapshotEdit from './viewComponents/Common/ModalSnapshotEdit';
import FabAssetsMenu from './viewComponents/Common/FabAssetsMenu';

// ###### MAIN COMPONENT
const AssetsDetailed = () => {
  const {
    assets,
    snapshot_items: snapshotItems,
    error,
    refreshFull,
    patchSnapshotItem,
  } = useAssetsData();

  const [assetToEdit, setAssetToEdit] = useState(null);
  const [returnToEdit, setReturnToEdit] = useState(null);
  const [snapshotItemToEdit, setSnapshotItemToEdit] = useState(null);
  const [snapshotToEdit, setSnapshotToEdit] = useState(null);
  const operationsUpdateRef = useRef(null);
  const returnsUpdateRef = useRef(null);
  const snapshotItemUpdateRef = useRef(null);

  return (
    <div className="flex flex-col gap-2 w-full mt-2">
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-3 py-2">
          {error}
        </div>
      )}
      <CardAssetsDetailed onEditAsset={setAssetToEdit} />
      {assetToEdit && (
        <ModalAssetEdit
          selectedAsset={assetToEdit}
          onClose={() => setAssetToEdit(null)}
          onSuccess={refreshFull}
        />
      )}
      <CardOperationsDetailed operationsUpdateRef={operationsUpdateRef} />
      <CardReturnsDetailed
        returnsUpdateRef={returnsUpdateRef}
        onReturnClick={setReturnToEdit}
      />
      {returnToEdit && (
        <ModalReturnEdit
          selectedReturn={returnToEdit}
          onClose={() => setReturnToEdit(null)}
          onSuccess={() => {
            setReturnToEdit(null);
            returnsUpdateRef.current?.();
          }}
        />
      )}

      <CardSnapshotsDetailed
        onEditItem={setSnapshotItemToEdit}
        snapshotItemUpdateRef={snapshotItemUpdateRef}
        onEditSnapshot={(snap) =>
          setSnapshotToEdit({
            snapshot: snap,
            items: snapshotItems.filter((i) => i.snapshot === snap.id),
          })
        }
      />
      {snapshotToEdit && (
        <ModalSnapshotEdit
          selectedSnapshot={snapshotToEdit.snapshot}
          items={snapshotToEdit.items ?? []}
          assets={assets}
          onClose={() => setSnapshotToEdit(null)}
          onSuccess={refreshFull}
        />
      )}
      {snapshotItemToEdit && (
        <ModalSnapshotItemEdit
          selectedItem={snapshotItemToEdit}
          onClose={() => setSnapshotItemToEdit(null)}
          onSuccess={(updatedItem) => {
            patchSnapshotItem(updatedItem);
            snapshotItemUpdateRef.current?.(updatedItem);
            setSnapshotItemToEdit(null);
          }}
        />
      )}

      <FabAssetsMenu assets={assets} onSuccess={refreshFull} />
    </div>
  );
};

export default AssetsDetailed;
